import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
// components
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import CircularProgressbar from 'react-circular-progressbar';
// styles
import styles from 'styles/components/lib/cards/CircularProgressCard.css';


export default class CircularProgressCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goal: this.props.goal,
      isLoading: true,
      showDialog: false,
      showValue: false,
      focused: false,
      tempValue: 0
    }
    this.getTextForPercentage = this.getTextForPercentage.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCardHover = this.handleCardHover.bind(this);
    this.handleChangeGoal = this.handleChangeGoal.bind(this);
    this.handleCircularClass = this.handleCircularClass.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmitGoal = this.handleSubmitGoal.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
    this.toggleValue = this.toggleValue.bind(this);
  };
  componentWillReceiveProps(nProps) {
    let { goal } = nProps;
    if (goal !== this.props.goal) {
      this.setState({
        goal: goal,
        isLoading: false
      });
    }
  }
  _setCurrentGoal(v) {
    this.setState({
      goal: numeral(v).value(),
    });
  }
  getPercentage () {
    let percentage = this._getPercentage();
    return percentage > 100 ? 100 : percentage;
  }
  _getPercentage () {
    let { value, goal } = this.props;
    return this.state.goal
      ? ((value/goal)) * 100
      : (this.state.focused) ? ((value/goal)) * 100 : 0;
  }
  getTextForPercentage () {
    let { goal, value } = this.props;
    let {  showValue } = this.state;
    if (showValue && value !== null) return this.getInitialValue();
    if (!showValue && goal) {
      if ((goal - value) > 0) {
        return `${Math.round(this._getPercentage())}%`;
      } else {
        return 0;
      }
    }
  }
  getInitialValue() {
    if (String(this.props.value).length > 11) {
      return numeral(this.props.value).format('0.00a');
    } else {
      return numeral(this.props.value).format('0,0[.]00');
    }
  }
  getCurrentGoal() {
    if (this.state.goal) {
      return numeral(this.state.goal).format('0,0[.]00');
    } else {
      return '';
    }
  }
  getMessage(difference) {
    //customize on components
    return '';
  }
  handleCancel() {
    this.setState({ goal: this.props.goal }, () => {
      this.toggleDialog();
    })
  }
  handleChangeGoal(event) {
    this.setState({ goal: numeral(event.target.value).value() });
  }
  handleKeyPress(event) {
    if(event.key === 'Enter' && this.state.goal !== null) {
      this.setState({ showDialog: true });
    }
  }
  handleCircularClass() {
    let { goal, value } = this.props;
    if (!this.state.showValue &&
      (!goal || goal <= value))
      return 'inactive';
  }
  handleSubmitGoal(event) {
      this.toggleDialog();
      this.setState({ focused: false });
      this.props.onSubmit(this.state.goal);
  }
  handleBlur(event) {
    let { isTouchDevice } = this.context.media;
    if(isTouchDevice) this.setState({ goal: this.props.goal});
    else if (this.state.goal !== this.props.goal) {
      if (this.state.goal === null) this.setState({ goal: this.props.goal });
      else this.setState({ showDialog: true });
    }
  }
  handleFocus() {
    this.setState({
      goal: null,
      focused: true
    });
  }
  handleCardHover() { // this.components
    let textInput = this.refs[this.props.title];
    textInput.setState({isFocused: !textInput.state.isFocused});
  }
  toggleDialog() {
    this.setState({ showDialog: !this.state.showDialog });
  }
  toggleValue() {
    this.setState({ showValue: !this.state.showValue });
  }
  render() {
    let { currency, goal, title, value } = this.props;
    let { showDialog, showValue } = this.state;
    let difference = goal ? goal - this.props.value : 0;
    let hasReachedGoal = goal && difference <= 0;
    let currentGoal = this.getCurrentGoal();
    let percentage = this.getPercentage();
    const actions = [
      <FlatButton label="Cancel" primary={false} onTouchTap={this.handleCancel} />,
      <FlatButton label="Submit" primary={true} onTouchTap={this.handleSubmitGoal} />
    ];
    return (
      <div className={styles.circularProgressCard} onMouseOver={this.handleCardHover} onMouseOut={this.handleCardHover}>
        <h6>{title}</h6>
        <div className={styles.container}>
          <div ref="cpc" className={styles.progressGraph} onTouchStart={this.toggleValue}  onMouseOver={this.toggleValue} onMouseOut={this.toggleValue}>
            <CircularProgressbar
              strokeWidth={4}
              percentage={this.getPercentage()}
              classForPercentage={this.handleCircularClass}
              initialAnimation={true}
              textForPercentage={this.getTextForPercentage} />
              { (!goal || hasReachedGoal)  && !showValue &&
                <h6 className={styles.goalMessage}>
                  { (value === null) ? 'Loading ...'
                    : !goal  ? 'Set Goal' : `You've reached your goal!`
                  }
                </h6>
              }
          </div>
          <div className={styles.info}>
              <Dialog
                title="Are you sure?"
                actions={actions}
                modal={true}
                open={ showDialog } >
                This change will affect the goal for every user in the organization.
              </Dialog>
              <TextField
                ref={title}
                floatingLabelFixed={true}
                floatingLabelStyle={{top: '22px'}}
                floatingLabelText="Your Goal"
                fullWidth={true}
                hintText={`${currency ? '$' : ''}0`}
                id={title}
                inputStyle={{height: '40px', marginBottom: '0px'}}
                maxLength="13"
                onBlur={this.handleBlur}
                onFocus={this.handleFocus}
                onChange={this.handleChangeGoal}
                onKeyPress={this.handleKeyPress}
                style={{height: '60px'}}
                value={currentGoal && currentGoal} />
              <div className={ styles.msgWrapper}>
                <p className={ difference  > 0 ? styles.activeMsg : styles.hiddenMsg}>{this.getMessage(difference)}</p>
              </div>
          </div>
        </div>
        <div className={goal ? styles.printable : styles.printNoProgress}>
            <p className={styles.printQty}>
              <span>
              	{this.getInitialValue()}
              	{goal ?
              			<span> / {this.getCurrentGoal()}</span>
              			: ''
              	}
              </span>
             </p>
            <LinearProgress
              mode="determinate"
              value={percentage && percentage} />
            <p className={hasReachedGoal ? styles.printGoalMsg : styles.printMessage}>
              { hasReachedGoal ?
                `You've reached your goal!`
                : goal ?
                  this.getMessage(difference)
                  : 'No goal set yet!'
              }
            </p>
        </div>
      </div>
    );
  };
}



CircularProgressCard.propTypes = {
  goal: PropTypes.number,
  value: PropTypes.number,
  productionId: PropTypes.number,
  onSubmit: PropTypes.func
}
CircularProgressCard.contextTypes = {
  media: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/scripts/components/lib/cards/CircularProgressCard.js